<template>
  <div class="noD">
    <span>t</span>
  </div>
</template>

<script>
export default {
  inject: ['tiptapProps'],
  mounted() {
    console.log(this.tiptapProps)
    setTimeout(() => {
      this.$emit('getWidth', this.tiptapProps)
    }, 100)
  },
  methods: {
    onMouseMove(width, height) {
      console.log('onMouseMove', width)
      this.tiptapProps.updateAttributes({ width: `${width}`, height: `${height}` })
    }
  }
}
</script>

<style scoped lang="less">
.noD {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
